export default __webpack_public_path__ + "static/media/Appdynamics.4cbd4848.svg";